import { useTheme } from '@mui/styles';

import {
  CELL_FONT_SIZE,
  CELL_SPACING,
  CELL_WIDTH,
  HEADER_DAY_HEIGHT,
  MONTH_GRAY,
  TODAY_COLOR,
  outOfRangeBackground,
} from '~/components/EmployeeCalendar/data';
import { cssColorHexToRgbA } from '~/utils/helpers/css';

export const useSxStyles = () => {
  const theme = useTheme();

  const getBGGradient = (bgColor: string, angle?: string) => {
    return `linear-gradient(${angle ?? '0deg'}, ${cssColorHexToRgbA(
      bgColor,
      0.87,
    )}, ${cssColorHexToRgbA(bgColor, 0.87)} 5%, ${cssColorHexToRgbA(
      bgColor,
      0,
    )} 100%, ${cssColorHexToRgbA(bgColor, 0)})`;
  };

  return {
    navigationWrapper: {
      display: 'flex',
      flexWrap: 'nowrap',
      alignContent: 'center',
      justifyContent: 'space-between',
      fontWeight: 'bold',
    },
    dayCells: {
      display: 'flex',
      flexWrap: 'nowrap',
      overflow: 'hidden',
      lineHeight: 1.3,
      fontWeight: 'bold',
      paddingBottom: '1px',
    },
    dayCellWrapper: {
      width: `${CELL_WIDTH}px`,
      height: `${HEADER_DAY_HEIGHT}px`,
      padding: `${CELL_SPACING}px`,
      paddingTop: `${CELL_SPACING * 2}px`,
      flexShrink: 0,
      textAlign: 'center',
      display: 'flex',
      boxSizing: 'content-box',
      borderRadius: `${theme.shape.borderRadius + CELL_SPACING}px ${
        theme.shape.borderRadius + CELL_SPACING
      }px 0 0`,
    },
    dayCellWrapperWithMonth: {
      position: 'relative',
      marginTop: '1.2rem',
    },
    dayCell: {
      width: `${CELL_WIDTH}px`,
      borderRadius: `${theme.shape.borderRadius + 1}px ${
        theme.shape.borderRadius + 1
      }px 0 0`,
      fontSize: CELL_FONT_SIZE,
    },
    dayCellMonth: {
      position: 'absolute',
      top: '-1.2rem',
      left: `${CELL_SPACING}px`,
      height: '1.2rem',
      whiteSpace: 'nowrap',
      fontSize: CELL_FONT_SIZE,
      padding: theme.spacing(0, 0.5),
      backgroundImage: getBGGradient(MONTH_GRAY, '90deg'),
      borderRadius: `${theme.shape.borderRadius + 1}px 0 0 ${
        theme.shape.borderRadius + 1
      }px`,
      textAlign: 'left',
      overflow: 'hidden',

      '&:after': {
        content: '""',
        display: 'block',
        position: 'absolute',
        top: 0,
        right: 0,
        height: '1.2rem',
        width: `${CELL_WIDTH}px`,
        backgroundImage: getBGGradient(
          theme.palette.background.default,
          '270deg',
        ),
      },
    },
    dayToday: {
      backgroundColor: TODAY_COLOR,
      position: 'relative',
      marginLeft: `${CELL_SPACING * -1}px`,
      marginRight: `${CELL_SPACING * -1}px`,
      paddingLeft: `${CELL_SPACING * 2}px`,
      paddingRight: `${CELL_SPACING * 2}px`,

      '&:after': {
        content: `''`,
        display: 'block',
        width: '100%',
        height: '1px',
        position: 'absolute',
        left: 0,
        bottom: '-1px',
        backgroundColor: TODAY_COLOR,
      },
    },
    startEndDates: {
      overflow: 'hidden',
      alignSelf: 'center',
      display: 'flex',
    },
    endOfRangeWrapper: {
      opacity: 0.3,
    },
    endOfRange: {
      color: theme.palette.text.disabled,
      backgroundImage: outOfRangeBackground,
    },
    hideOutOfRange: {
      display: 'none',
    },
  };
};
